import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'societename'
})
export class SocietenamePipe implements PipeTransform {

  transform(societe: any[], raisonsociale: string): any {
    if (raisonsociale != undefined && raisonsociale != ''){
      return societe.filter(client => {
        client.raisonsociale.toLowerCase().indexOf(raisonsociale.toLowerCase()) != -1;
      }
      );
    }
    return societe.filter(client => true);
  } 

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/societe/societename.pipe.ts